import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {ANALYTICS_ROUTES} from "@constants"
import AnalyticsDetailsPage from "./Details";


export const AnalyticsRoutes = {
    path: ANALYTICS_ROUTES.PATH,
    title: ANALYTICS_ROUTES.TITLE,
    accessKey: ANALYTICS_ROUTES.ACCESS_KEY,
    icon: 'sitemap',
	iconWeight: 'light',
    element: <AppLayout />,
    notRender: true,
    hideInHome: true,
    description: "Know and compare the product - price mix of different retailers",
    children: [{
        element: <Navigate to={ANALYTICS_ROUTES.DETAILS_PATH} replace/>,  index: true 
    }, {
        title: 'Catalogue Details',
        path: ANALYTICS_ROUTES.DETAILS_PATH,
        dashboardKey: ANALYTICS_ROUTES.DETAILS_ID,
        element: <AnalyticsDetailsPage />
    }]
}